/**
 * Typography Component
 *
 * Abstraction layer over MUI Typography.
 * Used for all text rendering with consistent styling.
 */

import { Typography as MuiTypography, TypographyProps } from '@mui/material';
import React from 'react';

const Typography = React.forwardRef<any, any>((props, ref) => {
  return <MuiTypography ref={ref} {...props} />;
});

Typography.displayName = 'Typography';

export default Typography;
